import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslationModule } from '../translation/translation.module';
import { IonicModule } from '@ionic/angular';
import { BasicLayoutComponent } from './basic-layout/basic-layout.component';
import { AppLayoutComponent } from './app-layout/app-layout.component';
import { ResponsiveContentComponent } from './responsive-content/responsive-content.component';
import { PortalModule } from '@angular/cdk/portal';

import { TabsNavigationComponent } from './tabs-navigation/tabs-navigation.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { PageHeaderComponent } from './page-header/page-header.component';
import { PageLayoutComponent } from './page-layout/page-layout.component';
import { LoadingComponent } from './loading/loading.component';
import { DirectivesModule } from '../../shared/directives/directives.module';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { UiNotificationsBadgeComponent } from '@bling-fe/shared/ui-components/ui-notifications-badge';
import { ReorderableListComponent } from '../../shared/components/reorderable-list/reorderable-list.component';

@NgModule()
export class LayoutIconsModule {}

@NgModule({
  declarations: [
    BasicLayoutComponent,
    AppLayoutComponent,
    TabsNavigationComponent,
    MainMenuComponent,
    PageHeaderComponent,
    PageLayoutComponent,
    ResponsiveContentComponent,
    LoadingComponent
  ],
  exports: [
    PageHeaderComponent,
    PageLayoutComponent,
    ResponsiveContentComponent,
    LoadingComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    IonicModule,
    PortalModule,
    TranslationModule,
    DirectivesModule,
    PipesModule,
    LayoutIconsModule,
    SvgIconComponent,
    UiNotificationsBadgeComponent,
    ReorderableListComponent
  ]
})
export class LayoutModule {}
